import { Component, OnInit } from "@angular/core";
import { delay } from "rxjs/operators";
import { SharedService } from "./services/shared.service";
import { dialogDTO } from "./shared/interfaces/shared.interface";
import { PrimeNGConfig } from "primeng/api";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  display = false;
  dialogData: dialogDTO = { title: "", message: "" };
  isLoading: boolean = false;

  constructor(private sharedService: SharedService,private primengConfig: PrimeNGConfig) {}

  ngOnInit() {
    this.primengConfig.setTranslation({
      dateFormat: 'M d, yy'  // Set global date format
    });
    this.sharedService.getDialogData.subscribe((res) => {
      if (res?.message.length > 0) {
        this.display = true;
        this.dialogData = res;
      } else {
        this.display = false;
        this.dialogData = res;
      }
    });

    this.sharedService.loaderSubject.pipe(delay(0)).subscribe((res) => {
      this.isLoading = res;
    });
  }
}
